export default __webpack_public_path__ + "static/we-work-with-d41cff5ae922cfc895b1839a2564c22f.svg";